import { type FC, type ReactNode } from 'react'

import MediaPlaceholderDarkIcon from '@/assets/images/media-placeholder-dark.svg'
import MediaPlaceholderLightIcon from '@/assets/images/media-placeholder-light.svg'
import { classNames } from '@/utils/helpers.ts'
import { useIsDarkTheme } from '@/utils/useTheme'

export const VaultMediaPlaceholder: FC<{
  body: ReactNode
  iconWidth?: number
  className?: string
}> = ({ body, iconWidth = 250, className }) => {
  const isDark = useIsDarkTheme()
  const PlaceholderIcon = isDark
    ? MediaPlaceholderDarkIcon
    : MediaPlaceholderLightIcon

  return (
    <div
      className={classNames(
        'col-span-4 flex h-[inherit] items-center justify-center',
        className,
      )}
    >
      <div className="flex flex-col items-center gap-2">
        <PlaceholderIcon width={iconWidth} />
        <div className="text-text-default">{body}</div>
      </div>
    </div>
  )
}
